import ConfigParameter, {gettext} from "../ConfigParameter";

export default class MapAddress extends ConfigParameter {

    constructor() {
        let defaultAddress = {
            textAddress: 'New York',
            coordinates: {
                lat: 40.7127753,
                lng: -74.0059728
            },
            zoom: 5,
        };

        super('address', 'map-address', gettext('Address'), 'mainConfig', defaultAddress);
    }
}



// WEBPACK FOOTER //
// ./src/cmsCore/Creator/ConfigParameters/ConfigParameters/MapAddress.js